import { render, staticRenderFns } from "./ReportIssueModal.vue?vue&type=template&id=783f6cda&"
import script from "./ReportIssueModal.vue?vue&type=script&lang=js&"
export * from "./ReportIssueModal.vue?vue&type=script&lang=js&"
import style0 from "./ReportIssueModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports